/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationPhysicalTypeModel } from '../../models/location-physical-type-model';

export interface LocationPhysicalTypeIdGet$Params {
  id: string;
}

export function locationPhysicalTypeIdGet(http: HttpClient, rootUrl: string, params: LocationPhysicalTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LocationPhysicalTypeModel>> {
  const rb = new RequestBuilder(rootUrl, locationPhysicalTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<LocationPhysicalTypeModel>;
    })
  );
}

locationPhysicalTypeIdGet.PATH = '/LocationPhysicalType/{id}';
